const getImageUrlFromData = (data, userThumbnailsEnabled = false) => {
  let imageUrl = null;

  const { isImagePresent, thumbnails, userThumbnails } =
    data?.userProfile?.profileImages || {};

  if (isImagePresent) {
    const selectedThumbnails = userThumbnailsEnabled ? userThumbnails : thumbnails;
    imageUrl = selectedThumbnails?.sizeX120;

    if (!imageUrl) {
      return null;
    }

    if (imageUrl && !imageUrl.includes('blob')) {
      imageUrl = `${imageUrl}&timeStamp=${Date.now()}`;
    }
  }

  return imageUrl;
};

export default getImageUrlFromData;
